import { gql } from 'graphql-request'

export const GlobalPeoplePageQuery = gql`
  query GlobalPeoplePage($locale: LocaleInputType!, $isPreview: Boolean! = false) {
    PeoplePage(locale: $locale, draft: $isPreview) {
      title
      maskShape ${fragmentMaskShapeQuery}
      pastTutors {
        id
        firstName
        lastName
        isExternal
        person {
          id
          slug
          title
          sortValue
        }
      }
    }
  }
`
